import { Injectable, isDevMode } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';

import { SessionQuery } from '../state/session.query';

@Injectable({ providedIn: 'root' })
export class UserRouteAccessService  {
  constructor(private router: Router, private sessionQuery: SessionQuery) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const currentUser = this.sessionQuery.getValue().user;

    const authorities: string | string[] = route.data['authorities'];

    if(!authorities || authorities.length === 0){
        return true;
    }

    if(currentUser) {
        return this.sessionQuery.hasAnyAuthority(authorities);
    }

    if (isDevMode()) {
        console.error('L\'utente non ha nessuna delle autority specificate: ', authorities);
      }

    return this.router.createUrlTree(['/']);
  }
}
